import SourceCode from './SourceCode';
import SourceTestament from './SourceTestament';
import SourceType from './SourceType';

interface Props {
    index: number;
    code: SourceCode;
    name: string;
    type: SourceType;
    testament: SourceTestament;
}

export default class Source {

    public constructor(private readonly props: Props) {
    }

    public getIndex(): number {
        return this.props.index;
    }

    public getCode(): SourceCode {
        return this.props.code;
    }

    public getName(): string {
        return this.props.name;
    }

    public getType(): SourceType {
        return this.props.type;
    }

    public getTestament(): SourceTestament {
        return this.props.testament;
    }
}
